type SubNav = Array<{
  to?,
  subNav?: SubNav
}>

type CheckIfActiveInput = {
  to: string
  pathname: string
  search: string
  subNav?: SubNav
}

// ATTN "to" could be undefined but we still should check if this item is active basing on children

const checkIfNavItemActive = ({ to, pathname, search, subNav }: CheckIfActiveInput) => {
  const isLinkWithQuery   = /\?/.test(to)
  const isActivePathname  = isLinkWithQuery ? to === `${pathname}${search}` : to === pathname

  return (
    isActivePathname
    || subNav && subNav.some(({ to, subNav }) => checkIfNavItemActive({ to, subNav, pathname, search }))
  )
}


export default checkIfNavItemActive
